import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IBasePatient
{
    name: string,
    username: string,
    patientId: number | string
}

const initialState: IBasePatient = {
    name: "",
    username: "",
    patientId: 0
}

/**
 * @deprecated
 */
export const patientSlice = createSlice({
    name: "patient",
    initialState: initialState,
    reducers: {
        setPatientName: (state, action: PayloadAction<{name: string, username: string, patientId: number | string}>) => {
            state.name = action.payload.name;
            state.username = action.payload.username;
            state.patientId = action.payload.patientId;
        },
        cleanPatientName: (state) => {
            state.name = ""
            state.username = ""
            state.patientId = 0
        },
    },
});

export const { setPatientName } = patientSlice.actions;
export default patientSlice.reducer;
